import { createContext, useContext, useState, FC, ReactNode } from "react";

import {
  IContextLogs,
  IListHistoryPlans,
  IListLogs,
  IValuesFilterLogs,
} from "./LogsContextTypes";
import { valuesDefaultFilterLogs } from "./valuesDefaultInputsLogs/valuesDefaultInputsLogs";

const LogsContext = createContext({} as IContextLogs);

export const LogsContextProvider: FC<{ children: ReactNode }> = ({
  children,
}) => {
  const [listLogs, setListLogs] = useState([] as IListLogs[]);

  const [listHistoryPlans, setListHistoryPlans] = useState<IListHistoryPlans[]>(
    [],
  );

  const [valuesFilterLogs, setValuesFilterLogs] = useState<IValuesFilterLogs>(
    valuesDefaultFilterLogs,
  );

  return (
    <LogsContext.Provider
      value={{
        listLogs,
        setListLogs,

        listHistoryPlans,
        setListHistoryPlans,

        valuesFilterLogs,
        setValuesFilterLogs,
      }}
    >
      {children}
    </LogsContext.Provider>
  );
};

export const useContextLogs = (): IContextLogs => useContext(LogsContext);
